import styled from 'styled-components'
import Flex from '../Flex'
import { counterVariant } from './variant'
import colors from '../../constants/colors'

export const CounterWrapper = styled(Flex)`
  box-sizing: border-box;
  width: fit-content;
  ${counterVariant};
`

export const InputCounter = styled.input<React.HTMLProps<HTMLInputElement>>`
  border: none;
  outline: none;
  text-align: center;
  padding: 0;
  font-weight: bold;
  font-size: 12px;
  flex: 1;
  color: ${colors.black100};
  overflow-y: auto;

  &:disabled {
    background-color: white;
  }
`
